var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCidbLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130.205,
    height: 53.5,
    viewBox: "0 0 130.205 53.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CIDB_LogoCMYK",
    transform: "translate(-31.82 -67.45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M218.53,144.207a10.18,10.18,0,0,1-9.665,6.939,10.672,10.672,0,0,1-7.224-2.91,10.308,10.308,0,1,1,16.885-10.681h-5.29a4.828,4.828,0,0,0-4.48-2.524,5.476,5.476,0,0,0-5.6,5.715A5.627,5.627,0,0,0,209,146.594a5.037,5.037,0,0,0,4.238-2.38h5.293Z",
    transform: "translate(-106.652 -40.307)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M263.09,118.428h-4.66V114.19h4.66Zm0,21.685h-4.66V120.672h4.66Z",
    transform: "translate(-145.008 -29.909)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M295.021,140.114h-4.307v-2.629h-.068a7.611,7.611,0,0,1-6.449,3.263c-5.567,0-9.636-4.977-9.636-10.266,0-5.221,3.255-10.266,9.777-10.443a7.623,7.623,0,0,1,5.992,2.665V114.19h4.692v25.924Zm-4.375-9.737a5.715,5.715,0,1,0-5.747,5.812A5.767,5.767,0,0,0,290.646,130.377Z",
    transform: "translate(-155.329 -29.909)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M356.933,130.409a11.589,11.589,0,0,1-2.485,7.076,9.313,9.313,0,0,1-7.152,3.262,7.359,7.359,0,0,1-6.511-3.262h-.072v2.629H336.44V114.19H341.1v8.549h.068c1.3-1.927,3.781-2.7,5.992-2.7C352.871,120.038,356.933,124.946,356.933,130.409Zm-4.656.036a5.561,5.561,0,0,0-5.6-5.816,5.662,5.662,0,0,0-5.852,5.538,5.734,5.734,0,0,0,5.852,6.024A5.507,5.507,0,0,0,352.277,130.445Z",
    transform: "translate(-194.926 -29.909)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_251",
    "data-name": "Group 251",
    transform: "translate(31.82 115.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M36.339,201.268H35.234a1.246,1.246,0,0,0-.465-.4,1.352,1.352,0,0,0-.619-.133,1.32,1.32,0,0,0-.994.432,1.548,1.548,0,0,0,0,2.092,1.415,1.415,0,0,0,1.606.3,1.222,1.222,0,0,0,.447-.364h1.1a2.429,2.429,0,0,1-.857,1.059,2.4,2.4,0,0,1-2.956-.338,2.5,2.5,0,0,1-.493-2.65,2.665,2.665,0,0,1,.537-.789,2.215,2.215,0,0,1,.749-.5,2.434,2.434,0,0,1,2.175.187A2.587,2.587,0,0,1,36.339,201.268Z",
    transform: "translate(-31.82 -199.81)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M45.76,204.737a1.8,1.8,0,0,1,.533-1.3,1.748,1.748,0,0,1,1.282-.54,1.8,1.8,0,0,1,1.318.529,1.759,1.759,0,0,1,.533,1.286,1.81,1.81,0,0,1-.529,1.336,1.773,1.773,0,0,1-1.314.537,1.737,1.737,0,0,1-1.293-.54A1.8,1.8,0,0,1,45.76,204.737Zm1.8-1.037a.916.916,0,0,0-.7.292,1.083,1.083,0,0,0-.266.756,1.038,1.038,0,0,0,.274.745,1.054,1.054,0,0,0,1.444,0,1.115,1.115,0,0,0,.263-.781.977.977,0,0,0-.284-.727A1,1,0,0,0,47.564,203.7Z",
    transform: "translate(-40.74 -201.787)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M58.582,203.062v.4a1.2,1.2,0,0,1,.407-.353,1.145,1.145,0,0,1,.529-.115,1.4,1.4,0,0,1,.652.144,1.193,1.193,0,0,1,.472.429,1.41,1.41,0,0,1,.18.439,3.427,3.427,0,0,1,.054.7v1.847h-.821v-1.545a1.976,1.976,0,0,0-.166-.965.61.61,0,0,0-.555-.256.644.644,0,0,0-.583.284,2.04,2.04,0,0,0-.173.987v1.494H57.79v-3.493h.792Z",
    transform: "translate(-48.438 -201.845)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M68.905,205.363v.061a.528.528,0,0,0,.119.364.377.377,0,0,0,.3.144.42.42,0,0,0,.3-.108.372.372,0,0,0,.112-.277.407.407,0,0,0-.09-.27,1.3,1.3,0,0,0-.393-.234c-.036-.014-.086-.036-.162-.061a1.763,1.763,0,0,1-.479-.263.876.876,0,0,1-.212-.32,1.141,1.141,0,0,1-.072-.41,1.006,1.006,0,0,1,.306-.742,1.033,1.033,0,0,1,.749-.306.993.993,0,0,1,.735.27,1.081,1.081,0,0,1,.3.756h-.72v-.018a.387.387,0,0,0-.09-.263.331.331,0,0,0-.248-.1.31.31,0,0,0-.227.094.33.33,0,0,0-.09.23c0,.155.162.3.472.425.13.05.23.1.31.137a1.091,1.091,0,0,1,.5.4,1.223,1.223,0,0,1-.173,1.419,1.144,1.144,0,0,1-.832.32,1.055,1.055,0,0,1-.817-.339,1.357,1.357,0,0,1-.335-.911h.745Z",
    transform: "translate(-55.074 -201.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M76.083,204.674V201.9H75.55v-.724h.533V200.05H76.9v1.131h.551v.724H76.9v2.769Z",
    transform: "translate(-59.803 -199.964)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M83.556,203.8a.946.946,0,0,0-.652.241,1.158,1.158,0,0,0-.191.76v1.779H81.9V203.09h.767v.4a1.249,1.249,0,0,1,.389-.342,1.139,1.139,0,0,1,.5-.112Z",
    transform: "translate(-63.866 -201.877)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M87.584,203.19H88.4V204.8a1.868,1.868,0,0,0,.162.929A.735.735,0,0,0,89.7,205.7a1.95,1.95,0,0,0,.184-.994V203.19h.792v3.493h-.792V206.3a1.17,1.17,0,0,1-.414.349,1.135,1.135,0,0,1-.529.119,1.273,1.273,0,0,1-1-.4,1.717,1.717,0,0,1-.353-1.16v-2.02Z",
    transform: "translate(-67.501 -201.973)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M100.846,204.247a1.042,1.042,0,0,0-.375-.411,1.028,1.028,0,0,0-.533-.133.911.911,0,0,0-.695.3,1.058,1.058,0,0,0-.277.749,1.007,1.007,0,0,0,.288.738.946.946,0,0,0,.709.3.993.993,0,0,0,.551-.14.841.841,0,0,0,.328-.425h.861a1.721,1.721,0,0,1-.612,1,1.855,1.855,0,0,1-2.971-1.469,1.794,1.794,0,0,1,.54-1.311,1.727,1.727,0,0,1,1.275-.544,1.83,1.83,0,0,1,1.149.36,1.719,1.719,0,0,1,.627.987Z",
    transform: "translate(-74.245 -201.787)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M109.663,204.674V201.9h-.533v-.724h.533V200.05h.81v1.131h.547v.724h-.547v2.769Z",
    transform: "translate(-81.291 -199.964)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M116.232,200.824h-.792v-.774h.792Zm-.792,3.849v-3.493h.792v3.493Z",
    transform: "translate(-85.328 -199.964)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M119.41,204.737a1.761,1.761,0,0,1,.533-1.3,1.72,1.72,0,0,1,1.275-.54,1.812,1.812,0,0,1,1.318.529,1.738,1.738,0,0,1,.54,1.286,1.824,1.824,0,0,1-.529,1.336,1.833,1.833,0,0,1-3.136-1.314ZM121.2,203.7a.893.893,0,0,0-.688.292,1.056,1.056,0,0,0-.274.756,1.023,1.023,0,0,0,.274.745.942.942,0,0,0,.72.284.918.918,0,0,0,.72-.288,1.088,1.088,0,0,0,.274-.781.968.968,0,0,0-.292-.727A1,1,0,0,0,121.2,203.7Z",
    transform: "translate(-87.869 -201.787)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M132.216,203.062v.4a1.117,1.117,0,0,1,.411-.353,1.1,1.1,0,0,1,.522-.115,1.411,1.411,0,0,1,.659.144,1.278,1.278,0,0,1,.645.868,3.427,3.427,0,0,1,.054.7v1.847h-.817v-1.545a1.986,1.986,0,0,0-.162-.965.618.618,0,0,0-.565-.256.632.632,0,0,0-.576.284,1.937,1.937,0,0,0-.184.987v1.494h-.781v-3.493h.8Z",
    transform: "translate(-95.554 -201.845)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M147.42,204.68v-4.62h.9v4.62Z",
    transform: "translate(-105.792 -199.97)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M153.136,203.062v.4a1.177,1.177,0,0,1,.411-.353,1.114,1.114,0,0,1,.522-.115,1.416,1.416,0,0,1,.663.144,1.166,1.166,0,0,1,.461.429,1.2,1.2,0,0,1,.184.439,3.378,3.378,0,0,1,.058.7v1.847h-.821v-1.545a1.985,1.985,0,0,0-.162-.965.622.622,0,0,0-.565-.256.628.628,0,0,0-.576.284,1.937,1.937,0,0,0-.184.987v1.494h-.785v-3.493h.8Z",
    transform: "translate(-108.941 -201.845)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M166.3,200.037v4.62h-.8l.018-.385a1.556,1.556,0,0,1-.508.356,1.464,1.464,0,0,1-.6.119,1.731,1.731,0,0,1-1.286-.533,1.839,1.839,0,0,1-.519-1.314,1.767,1.767,0,0,1,.526-1.286,1.7,1.7,0,0,1,1.271-.533,1.66,1.66,0,0,1,.594.1,1.63,1.63,0,0,1,.519.335.6.6,0,0,1-.014-.14c0-.047-.007-.119-.007-.22V200.03h.8Zm-1.79,1.851a1.017,1.017,0,0,0-.753.3,1,1,0,0,0-.3.735.986.986,0,0,0,.3.731,1,1,0,0,0,.742.3.966.966,0,0,0,.72-.288,1,1,0,0,0,.288-.727,1.041,1.041,0,0,0-.288-.749A.951.951,0,0,0,164.508,201.888Z",
    transform: "translate(-115.512 -199.951)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M174.95,203.19h.81V204.8a1.819,1.819,0,0,0,.166.929.62.62,0,0,0,.555.252.637.637,0,0,0,.591-.288,2.046,2.046,0,0,0,.176-.994V203.19h.8v3.493h-.8V206.3a1.14,1.14,0,0,1-.936.468,1.294,1.294,0,0,1-1.012-.4,1.716,1.716,0,0,1-.349-1.16Z",
    transform: "translate(-123.409 -201.973)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M186.225,205.363v.061a.585.585,0,0,0,.115.364.383.383,0,0,0,.306.144.421.421,0,0,0,.3-.108.362.362,0,0,0,.115-.277.393.393,0,0,0-.1-.27,1.252,1.252,0,0,0-.393-.234c-.036-.014-.083-.036-.155-.061a1.558,1.558,0,0,1-.479-.263.943.943,0,0,1-.22-.32,1.141,1.141,0,0,1-.072-.41,1.051,1.051,0,0,1,1.059-1.048,1,1,0,0,1,.735.27,1.081,1.081,0,0,1,.3.756h-.72v-.018a.37.37,0,0,0-.09-.263.317.317,0,0,0-.245-.1.273.273,0,0,0-.22.094.318.318,0,0,0-.094.23c0,.155.158.3.472.425.126.05.23.1.31.137a1.155,1.155,0,0,1,.508.4,1.14,1.14,0,0,1,.148.612,1.088,1.088,0,0,1-.328.807,1.141,1.141,0,0,1-.828.32,1.047,1.047,0,0,1-.814-.339,1.341,1.341,0,0,1-.338-.911h.735Z",
    transform: "translate(-130.153 -201.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M193.4,204.674V201.9h-.533v-.724h.533V200.05h.81v1.131h.547v.724h-.547v2.769Z",
    transform: "translate(-134.876 -199.964)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M200.869,203.8a.961.961,0,0,0-.652.241,1.16,1.16,0,0,0-.187.76v1.779h-.81V203.09h.76v.4a1.194,1.194,0,0,1,.4-.342,1.084,1.084,0,0,1,.493-.112Z",
    transform: "translate(-138.939 -201.877)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M204.3,203.19h.861l.85,2.438.936-2.438h.857l-1.887,4.62h-.843l.49-1.228Z",
    transform: "translate(-142.19 -201.973)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M222.176,204.68H220.61v-4.62h1.545a3.521,3.521,0,0,1,.9.094,1.82,1.82,0,0,1,.619.31,2.037,2.037,0,0,1,.627.8,2.737,2.737,0,0,1,.216,1.127,2.567,2.567,0,0,1-.238,1.12,2.113,2.113,0,0,1-.688.821,1.738,1.738,0,0,1-.565.266A3.653,3.653,0,0,1,222.176,204.68Zm-.054-.8a2.177,2.177,0,0,0,.677-.083,1.155,1.155,0,0,0,.429-.288,1.2,1.2,0,0,0,.259-.465,2,2,0,0,0,.094-.634,1.648,1.648,0,0,0-.375-1.163,1.43,1.43,0,0,0-1.091-.4h-.591v3.039h.6Z",
    transform: "translate(-152.627 -199.97)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M233.609,205.007a.872.872,0,0,0,.3.594,1.033,1.033,0,0,0,.677.22,1.054,1.054,0,0,0,.479-.112.8.8,0,0,0,.342-.324h.886a1.853,1.853,0,0,1-.67.882,1.821,1.821,0,0,1-2.326-.22,1.769,1.769,0,0,1-.526-1.293,1.8,1.8,0,0,1,.529-1.311,1.7,1.7,0,0,1,1.264-.544,1.759,1.759,0,0,1,1.314.547,1.854,1.854,0,0,1,.533,1.365,1.02,1.02,0,0,1,0,.119.558.558,0,0,0,0,.076h-2.794Zm1.927-.645a.935.935,0,0,0-.346-.529,1.026,1.026,0,0,0-.627-.184.926.926,0,0,0-.583.2.975.975,0,0,0-.342.511Z",
    transform: "translate(-160.408 -201.787)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M245.993,206.683h-.637l-1.325-3.493h.864l.814,2.319.839-2.319h.846Z",
    transform: "translate(-167.613 -201.973)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M255.279,205.007a.844.844,0,0,0,.3.594,1.013,1.013,0,0,0,.67.22,1.047,1.047,0,0,0,.483-.112.878.878,0,0,0,.346-.324h.886a1.853,1.853,0,0,1-.67.882,1.821,1.821,0,0,1-2.326-.22,1.769,1.769,0,0,1-.526-1.293,1.8,1.8,0,0,1,.529-1.311,1.7,1.7,0,0,1,1.264-.544,1.759,1.759,0,0,1,1.314.547,1.856,1.856,0,0,1,.537,1.365,1.02,1.02,0,0,1,0,.119c0,.025,0,.054,0,.076h-2.8Zm1.923-.645a.993.993,0,0,0-.346-.529,1.026,1.026,0,0,0-.627-.184.926.926,0,0,0-.583.2.916.916,0,0,0-.342.511Z",
    transform: "translate(-174.274 -201.787)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M266.31,204.68v-4.62h.8v4.62Z",
    transform: "translate(-181.87 -199.97)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M270.27,204.737a1.779,1.779,0,0,1,.537-1.3,1.746,1.746,0,0,1,1.278-.54,1.786,1.786,0,0,1,1.314.529,1.746,1.746,0,0,1,.533,1.286,1.807,1.807,0,0,1-.526,1.336,1.773,1.773,0,0,1-1.314.537,1.751,1.751,0,0,1-1.3-.54A1.816,1.816,0,0,1,270.27,204.737Zm1.8-1.037a.908.908,0,0,0-.695.292,1.083,1.083,0,0,0-.267.756,1.023,1.023,0,0,0,.274.745.934.934,0,0,0,.717.284.952.952,0,0,0,.724-.288,1.116,1.116,0,0,0,.263-.781.99.99,0,0,0-.284-.727A1,1,0,0,0,272.074,203.7Z",
    transform: "translate(-184.404 -201.787)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M282.15,207.65v-4.62h.8l-.025.385a1.556,1.556,0,0,1,.508-.357,1.476,1.476,0,0,1,.6-.119,1.736,1.736,0,0,1,1.286.533,1.893,1.893,0,0,1,0,2.607,1.716,1.716,0,0,1-1.271.533,1.541,1.541,0,0,1-.591-.108,1.752,1.752,0,0,1-.526-.342.443.443,0,0,1,.014.14c0,.047.007.119.007.22v1.127Zm1.786-1.844a1.029,1.029,0,0,0,.753-.3,1.012,1.012,0,0,0,.3-.731.98.98,0,0,0-.3-.731.99.99,0,0,0-.738-.292.955.955,0,0,0-.72.288.98.98,0,0,0-.284.724,1.033,1.033,0,0,0,.284.749A.924.924,0,0,0,283.936,205.806Z",
    transform: "translate(-192.006 -201.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M297.094,203.7a1.341,1.341,0,0,1,.45-.522,1.123,1.123,0,0,1,.619-.18,1.222,1.222,0,0,1,.983.4,1.694,1.694,0,0,1,.353,1.156v2h-.8v-1.689a1.572,1.572,0,0,0-.162-.832.6.6,0,0,0-.547-.248.626.626,0,0,0-.573.284,2.09,2.09,0,0,0-.169.99v1.494h-.8v-1.545a.5.5,0,0,0,0-.05v-.09a1.551,1.551,0,0,0-.169-.835.609.609,0,0,0-.551-.245.6.6,0,0,0-.555.292,2.106,2.106,0,0,0-.169.983v1.494h-.825v-3.493h.792v.4a1.147,1.147,0,0,1,.421-.357,1.27,1.27,0,0,1,.555-.112,1.211,1.211,0,0,1,1.156.7Z",
    transform: "translate(-199.698 -201.851)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M311.605,205.007a.817.817,0,0,0,.3.594,1,1,0,0,0,.666.22,1.077,1.077,0,0,0,.49-.112.845.845,0,0,0,.342-.324h.886a1.869,1.869,0,0,1-.666.882,1.821,1.821,0,0,1-2.326-.22,1.769,1.769,0,0,1-.526-1.293,1.8,1.8,0,0,1,.533-1.311,1.694,1.694,0,0,1,1.257-.544,1.769,1.769,0,0,1,1.322.547,1.882,1.882,0,0,1,.533,1.365,1.02,1.02,0,0,1,0,.119.486.486,0,0,1-.007.076h-2.8Zm1.919-.645a.935.935,0,0,0-.346-.529,1.018,1.018,0,0,0-.619-.184.919.919,0,0,0-.583.2.887.887,0,0,0-.346.511Z",
    transform: "translate(-210.32 -201.787)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M323.516,203.062v.4a1.235,1.235,0,0,1,.407-.353,1.124,1.124,0,0,1,.529-.115,1.391,1.391,0,0,1,.652.144,1.243,1.243,0,0,1,.472.429,1.411,1.411,0,0,1,.18.439,3.477,3.477,0,0,1,.05.7v1.847h-.817v-1.545a1.976,1.976,0,0,0-.166-.965.61.61,0,0,0-.555-.256.644.644,0,0,0-.583.284,2.04,2.04,0,0,0-.173.987v1.494h-.792v-3.493h.8Z",
    transform: "translate(-217.967 -201.845)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M333.093,204.674V201.9h-.533v-.724h.533V200.05h.814v1.131h.547v.724h-.547v2.769Z",
    transform: "translate(-224.263 -199.964)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M344.58,204.68v-4.62h1.177a1.453,1.453,0,0,1,1.008.346,1.141,1.141,0,0,1,.385.886,1.113,1.113,0,0,1-.126.551.817.817,0,0,1-.349.349.949.949,0,0,1,.533.389,1.188,1.188,0,0,1,.2.688,1.5,1.5,0,0,1-.144.663,1.26,1.26,0,0,1-.853.684,2.807,2.807,0,0,1-.681.061H344.58Zm.868-2.762h.108a.909.909,0,0,0,.555-.137.5.5,0,0,0,.18-.428.4.4,0,0,0-.18-.36.949.949,0,0,0-.529-.122h-.137v1.048Zm0,1.948h.277a1.073,1.073,0,0,0,.6-.137.486.486,0,0,0,.194-.428.557.557,0,0,0-.205-.472.9.9,0,0,0-.591-.166h-.277v1.2Z",
    transform: "translate(-231.955 -199.97)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M354.01,204.737a1.793,1.793,0,0,1,.537-1.3,1.746,1.746,0,0,1,1.278-.54,1.806,1.806,0,0,1,1.318.529,1.756,1.756,0,0,1,.529,1.286,1.807,1.807,0,0,1-.526,1.336,1.773,1.773,0,0,1-1.314.537,1.743,1.743,0,0,1-1.293-.54A1.8,1.8,0,0,1,354.01,204.737Zm1.8-1.037a.908.908,0,0,0-.695.292,1.083,1.083,0,0,0-.266.756,1.023,1.023,0,0,0,.274.745,1.045,1.045,0,0,0,1.437,0,1.1,1.1,0,0,0,.266-.781.991.991,0,0,0-.285-.727A1,1,0,0,0,355.814,203.7Z",
    transform: "translate(-237.989 -201.787)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M368.326,206.529l.011-.483a1.177,1.177,0,0,1-.45.425,1.369,1.369,0,0,1-.648.137,1.743,1.743,0,0,1-1.293-.526,1.893,1.893,0,0,1-.011-2.607,1.724,1.724,0,0,1,1.282-.526,1.376,1.376,0,0,1,.612.137,1.533,1.533,0,0,1,.5.414l-.022-.461h.8v3.493h-.781Zm-2.063-1.775a1.01,1.01,0,0,0,.3.742,1.046,1.046,0,0,0,.756.292,1.008,1.008,0,0,0,1-1,1.015,1.015,0,0,0-1.041-1.037,1,1,0,0,0-1.012,1Z",
    transform: "translate(-245.29 -201.819)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M379.549,203.8a1,1,0,0,0-.655.241,1.163,1.163,0,0,0-.184.76v1.779h-.81V203.09h.763v.4a1.193,1.193,0,0,1,.4-.342,1.084,1.084,0,0,1,.493-.112v.763Z",
    transform: "translate(-253.276 -201.877)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M386.854,200.037v4.62h-.8l.018-.385a1.46,1.46,0,0,1-.5.356,1.511,1.511,0,0,1-.6.119,1.718,1.718,0,0,1-1.275-.533,1.809,1.809,0,0,1-.519-1.314,1.761,1.761,0,0,1,.519-1.286,1.706,1.706,0,0,1,1.268-.533,1.632,1.632,0,0,1,.594.1,1.592,1.592,0,0,1,.519.335c-.007-.047-.011-.09-.014-.14s-.007-.119-.007-.22V200.03h.807Zm-1.8,1.851a1.029,1.029,0,0,0-.753.3,1.014,1.014,0,0,0-.3.735,1.015,1.015,0,0,0,1.041,1.026.966.966,0,0,0,.72-.288,1.008,1.008,0,0,0,.285-.727,1.054,1.054,0,0,0-.285-.749A.916.916,0,0,0,385.057,201.888Z",
    transform: "translate(-256.648 -199.951)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M72.32,91.62,55.41,104.609V105.8h5.556v-5.448H66.76V126.1h5.56Z",
    transform: "translate(-15.095 -15.466)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M102.37,76.154h5.794v34.483h5.56V67.45Z",
    transform: "translate(-45.145)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M149.98,97.86V130.1h5.564V102.134Z",
    transform: "translate(-75.61 -19.459)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_283",
    "data-name": "Rectangle 283",
    width: 5.556,
    height: 21.293,
    transform: "translate(40.315 89.344)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_284",
    "data-name": "Rectangle 284",
    width: 14.001,
    height: 6.489,
    transform: "translate(74.37 89.142)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M40.411,127.69l-8.441,6.489h14V127.69Z",
    transform: "translate(-0.096 -38.548)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_285",
    "data-name": "Rectangle 285",
    width: 16.914,
    height: 6.489,
    transform: "translate(51.665 89.142)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M118.46,157.54v6.485h16.914l8.437-6.485Z",
    transform: "translate(-55.441 -57.648)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M31.97,157.54H57.321v6.489H31.97V157.54Z",
    transform: "translate(-0.096 -57.648)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCidbLogoWhite);
export default __webpack_public_path__ + "static/media/CIDB_Logo_white.378faa19984f15e874dd5f7174d863b1.svg";
export { ForwardRef as ReactComponent };